import React from "react";

import "./Footer.css";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="containerFooter">
          <p>ADS &copy; 2024</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
